import { STATUS_COLOR, STATUS_LABEL } from "features/ConsultRequest/core/constants";

export default function StatusText({ status }) {
  return <span style={{ color: STATUS_COLOR[status], fontWeight: 600 }}>{STATUS_LABEL[status] || status}</span>;
}
